export default {"src":"/_next/static/media/bike.5961f7c1.svg","height":64,"width":64};